import React from 'react'
import { pluralize } from 'humanize-plus'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { Select } from '@driftt/tide-core-legacy'
import './style.styl'


const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE

const DelayTime = ({ value, onUpdate, unit, pickUnits, delayCopy }) => {
  const humanizedValue = value / (unit === 'hour' ? HOUR : MINUTE)
  return <div className="meeting-email-template-modal-delay-editor">
    <span>We’ll send this email</span>
    <div className="delay-time-wrapper">
      <input type="number" value={humanizedValue} onChange={(e) => {
        if (e.target.value >= 0) onUpdate(e.target.value * (unit === 'hour' ? HOUR : MINUTE))}
       } />
      <Select
        className="units"
        options={[
          {
            value: 'hour',
            label: pluralize(humanizedValue, 'Hour', 'Hours')
          },
          {
            value: 'minute',
            label: pluralize(humanizedValue, 'Minute', 'Minutes')
          }]}
        value={unit}
        onChange={pickUnits}
        clearable={false}
        searchable={false}
      />
    </div>
    <span>{delayCopy}</span>
  </div>
}

export default compose(
  withState(
    'unit', 'setUnit', props => _.isInteger(props.value / HOUR) ? 'hour' : 'minute'
  ),
  withHandlers({
    pickUnits: props => ({ value }) => {
      props.setUnit(value)
    }
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (this.props.selectedSettingName !== nextProps.selectedSettingName) {
        nextProps.setUnit(_.isInteger(nextProps.value / HOUR) ? 'hour' : 'minute')
      }
    }
  })
)(DelayTime)



// WEBPACK FOOTER //
// ./src/scripts/components/EmailTemplateModal/DelayTime/index.js